import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path d="M12 4L4 12" stroke="#72808F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 4L12 12" stroke="#72808F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default SvgComponent
